<template>
  <CBreadcrumb v-bind="props" :items="items">
    <slot></slot>
  </CBreadcrumb>
</template>

<script>
import Vue from 'vue'
import CBreadcrumb from '@coreui/vue/src/components/breadcrumb/CBreadcrumb'

export default {
  name: 'BreadcrumbRouter',
  components: {
    CBreadcrumb
  },
  props: {
    addClasses: [String, Array, Object],
    addLinkClasses: [String, Array, Object],
    addLastItemClasses: [String, Array, Object]
  },
  data () {
    return {
      items: []
    }
  }, 
  watch: {
    async '$route' (to, from) {
      this.$store.dispatch('navigation/setRouteLabel', '')
      this.setItems(to)
    },
    '$store.state.navigation.routeLabel' (to, from) {
      console.log('BreadcrumbRouter watch $store.state.navigation.routeLabel', to, from)
      this.setItems(this.$route)
    },
  },
  computed: {
    props () {
      return {
        addClasses: this.addClasses,
        addLinkClasses: this.addLinkClasses,
        addLastItemClasses: this.addLastItemClasses
      }
    }
  },
  methods: {
    setItems (route) {
      const items = route.matched
        .filter(item => item.path !== '')
        .map(item => {
          const text = item.meta?.isDynamic ? this.$store.state.navigation.routeLabel : (item.meta?.defaultLabel || item.name)
          return { text: text, to: item.path }
        }) 
      this.items = items    
    }
  }
}
</script>
